<template>
  <v-app id="inspire">
    <v-container
      class="fill-height"
      fluid
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="4"
        >
          <v-card class="elevation-12" v-if="isLogin">
            <v-toolbar
              color="primary"
              dark
              flat
            >
              <v-toolbar-title>Вход в систему бронирования</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field
                  :error-messages="errors['phone_number'] || []"
                  label="Логин"
                  name="phone_number"
                  prepend-icon="mdi-account"
                  type="text"
                  v-model="phone_number"
                ></v-text-field>

                <v-text-field
                  :error-messages="errors['password'] || []"
                  id="password"
                  label="Пароль"
                  name="password"
                  prepend-icon="mdi-lock"
                  type="password"
                  v-model="password"
                ></v-text-field>
              </v-form>
            </v-card-text>
              <v-spacer></v-spacer>
            <v-card-actions class="d-flex justify-space-between mb-6">
              <router-link  rel="nofollow" tag="a" :to="{name:'Register'}" class="border-bottom" target>
                Ещё нету аккаунта ?
              </router-link>
              <v-btn color="primary"  :loading="loading" @click="signIn()">Войти</v-btn>
            </v-card-actions>
          </v-card>
          <confirm-phone-component
            v-show="isConfirm"
            :number-phone="phone_number"
            :url-send="uriConfirmationPhone"
            @successActivationCode='signIn'
          >

          </confirm-phone-component>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
  const STAGE_LOGIN = 'login';
  const STAGE_CONFIRM = 'confirm';

  import ConfirmPhoneComponent from "./ConfirmPhoneComponent";

  import {
    ValidationObserver,
    ValidationProvider,
    withValidation
  } from "vee-validate";

  const URI_CONFIRMATION_PHONE  = '/auth/signup/activate-phone';

  export default {
    props: {
      source: String,
    },
    components: {
      ValidationProvider,
      ValidationObserver,
      ConfirmPhoneComponent
    },
    data() {
      return {
        uriConfirmationPhone: URI_CONFIRMATION_PHONE,
        stage: STAGE_LOGIN,
        errors: [],
        loading: false,
        phone_number: "",
        password: ""
      }
    },
    computed:{
      isLogin() {
        return this.stage === STAGE_LOGIN
      },
      isConfirm() {
        return this.stage === STAGE_CONFIRM
      },
    },
    methods: {
      signIn() {
        if(this.loading){
          return;
        }

        this.loading = true;

        let data = {
          phone_number : this.phone_number,
          password : this.password
        }

        auth.login(data)
        .then((data) => {
          this.loading = false;
          this.$router.push({'path' : '/'})
        })
        .catch(error => {
          this.loading = false;
          let response = error.response;
          this.errors = error.response.data.errors;

          if(response.status === 403){
            this.stage = STAGE_CONFIRM;
          }
        })
      }
    }
  }
</script>
<style>
  #inspire {
    background-color: #E0F2F1;
  }
</style>
